export const _import = file => () => import('@/views/' + file + '.vue')
